module.exports = __webpack_public_path__ + "static/media/tabletojson.21417557.svg";